// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<path d="M11.4285714,3.28571429 L4.57142857,1 L0,3.28571429 L0,14.7142857 L4.57142857,
				12.4285714 L11.4285714,14.7142857 L16,12.4285714 L16,1 L11.4285714,3.28571429 Z
				M10.2857143,13.1291429 L5.71428571,11.6057143 L5.71428571,2.58514286 L10.2857143,
				4.10857143 L10.2857143,13.1291429 Z" fillRule="nonzero" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Guide.js